import type { TutorLegalAccountFieldConfig, TutorLegalFieldConfig, TutorLegalFieldMapEntry, TutorLegalForm } from '../model/legal/interfaces'

import { TutorBillingAccountType } from '@shared/model'

// Payment services from the lists enum that must not be offered.
export const TUTOR_LEGAL_EXCLUDED_PAYMENT_SERVICES: string[] = ['WIRE']

// Nullable on the backend — not required in the form.
export const TUTOR_LEGAL_OPTIONAL_FIELDS: (keyof TutorLegalForm)[] = ['account_holder_name', 'billing_id']

export const TUTOR_LEGAL_FIELD_MAP: TutorLegalFieldMapEntry[] = [
  { form: 'first_name', section: 'personal', api: 'first_name' },
  { form: 'middle_name', section: 'personal', api: 'middle_name' },
  { form: 'last_name', section: 'personal', api: 'last_name' },
  { form: 'date_of_birth', section: 'personal', api: 'date_of_birth' },
  { form: 'nationality', section: 'personal', api: 'nationality' },
  { form: 'place_of_birth', section: 'personal', api: 'place_of_birth' },
  { form: 'city_of_living', section: 'personal', api: 'city_of_living' },
  { form: 'state_of_living', section: 'personal', api: 'state_of_living' },
  { form: 'address_of_living', section: 'personal', api: 'address_of_living' },
  { form: 'document_type', section: 'document', api: 'type' },
  { form: 'document_id', section: 'document', api: 'number' },
  { form: 'payment_service', section: 'payment', api: 'payment_service' },
  { form: 'account', section: 'payment', api: 'account' },
  { form: 'account_holder_name', section: 'payment', api: 'account_holder_name' },
  { form: 'billing_id', section: 'personal', api: 'reference_number' },
]

export const TUTOR_LEGAL_PERSONAL_FIELDS: TutorLegalFieldConfig[] = [
  { key: 'first_name', label: 'First name' },
  { key: 'middle_name', label: 'Middle name', tooltip: 'Tutor\'s middle name as stated in the document' },
  { key: 'last_name', label: 'Last name' },
  { key: 'date_of_birth', label: 'Date of birth', tooltip: 'Format: YYYY-MM-DD', type: 'date' },
  { key: 'nationality', label: 'Nationality' },
]

export const TUTOR_LEGAL_ADDRESS_FIELDS: TutorLegalFieldConfig[] = [
  { key: 'place_of_birth', label: 'Place of birth', tooltip: 'City and country of birth' },
  { key: 'city_of_living', label: 'City of living' },
  { key: 'state_of_living', label: 'State of living', tooltip: 'State, province or area of living' },
  { key: 'address_of_living', label: 'Address of living', tooltip: 'Full residential address' },
]

export const TUTOR_LEGAL_ACCOUNT_FIELDS: Record<TutorBillingAccountType, TutorLegalAccountFieldConfig> = {
  [TutorBillingAccountType.Phone]: {
    label: 'Account phone number',
    placeholder: 'e.g. +63 123 456 7890',
    error: 'This field requires a valid phone number.',
  },
  [TutorBillingAccountType.Email]: {
    label: 'Account email',
    placeholder: 'e.g. example@domain.com',
    error: 'This field requires a valid email address.',
  },
  [TutorBillingAccountType.Text]: {
    label: 'Account',
    placeholder: '',
    error: '',
  },
}

export const TUTOR_LEGAL_ACCOUNT_HOLDER_NAME_MAX_LENGTH = 128
